<div class="swal2-container swal2-center swal2-fade" style="overflow-y: auto;">
  <div role="dialog" aria-modal="true" aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show"
    tabindex="-1" aria-live="assertive" style="width: 500px; padding: 2.5rem; background: rgb(255, 255, 255); display: flex;">
    <ul class="swal2-progresssteps" style="display: none;"></ul>
    <div class="swal2-icon swal2-error" style="display: none;">
      <span class="swal2-x-mark">
        <span class="swal2-x-mark-line-left"></span>
        <span class="swal2-x-mark-line-right"></span>
      </span>
    </div>
    <div class="swal2-icon swal2-question" style="display: none;">?</div>
    <div class="swal2-icon swal2-warning" style="display: none;">!</div>
    <div class="swal2-icon swal2-info" style="display: none;">i</div>
    <!--Success Image-->
    <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: block;" *ngIf="message.one !== 'Cancelled' && message.text !== 'Delete'">
      <div class="swal2-success-circular-line-left" style="background: rgb(255, 255, 255);"></div>
      <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
      <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
      <div class="swal2-success-ring"></div>
      <div class="swal2-success-fix" style="background: rgb(255, 255, 255);"></div>
      <div class="swal2-success-circular-line-right" style="background: rgb(255, 255, 255);"></div>
    </div>
    <!-- Cancelled Image -->
    <div class="swal2-icon swal2-error swal2-animate-error-icon" style="display: block;" *ngIf="message.one === 'Cancelled'">
      <span class="swal2-x-mark swal2-animate-x-mark">
        <span class="swal2-x-mark-line-left"></span>
        <span class="swal2-x-mark-line-right"></span>
      </span>
    </div>
    <!--Delete Image-->
    <div class="swal2-icon swal2-warning" style="display: block;" *ngIf="message.text === 'Delete'">!</div>
    <img class="swal2-image" style="display: none;">
    <div class="swal2-contentwrapper">
      <h2 class="swal2-title" id="swal2-title">{{message.one}}</h2>
      <div id="swal2-content" class="swal2-content" style="display: block;">{{message.two}}</div>
    </div>
    <input class="swal2-input" style="display: none;">
    <input type="file" class="swal2-file" style="display: none;">
    <div class="swal2-range" style="display: none;">
      <output></output>
      <input type="range">
    </div>
    <select class="swal2-select" style="display: none;"></select>
    <div class="swal2-radio" style="display: none;"></div>
    <label for="swal2-checkbox" class="swal2-checkbox" style="display: none;">
      <input type="checkbox">
    </label>
    <textarea class="swal2-textarea" style="display: none;"></textarea>
    <div class="swal2-validationerror" id="swal2-validationerror" style="display: none;"></div>
    <div class="swal2-buttonswrapper" style="display: flex;">
      <button type="button" [class]="(message.textClass) ? message.textClass : 'swal2-confirm btn btn-success m-btn m-btn--custom' " aria-label="" (click)="continue(message.text)">{{message.text}}
      </button>
      <button type="button" [class]="(message.text1Class) ? message.text1Class : 'swal2-confirm btn btn-success m-btn m-btn--custom' " *ngIf="message.text1" aria-label="" (click)="continue(message.text1)">{{message.text1}}</button>
      <button type="button" *ngIf="!message.text1" class="swal2-cancel btn btn-secondary m-btn m-btn--custom" aria-label="" (click)="continue('Cancel')">Cancel</button>
    </div>
    <button type="button" class="swal2-close"  (click)="continue('closeModal')">×</button>
  </div>
</div>